import { Field } from 'src/app/models/field/field.model';
import { DisplayType } from './display-type.enum';
import { FieldType } from './field-type.enum';
import { FieldBase } from './field-base.model';

export class CodingField extends FieldBase {
  parentFieldId: string;
  caseId: string;
  type: number;

  constructor(codingField: CodingField) {
    super();
    this.parentFieldId = codingField.parentFieldId;
    this.caseId = codingField.caseId;
    this.displayTitle = codingField.displayTitle;
    this.fieldId = codingField.fieldId;
    this.rank = codingField.rank;
    this.type = codingField.type;
  }

  toField(): Field {
    let displayType = DisplayType.Custom;
    let propName: string;
    let width = 20;
    switch (this.type) {
      case FieldType.SectionSeparator:
        // Section (parent field) - no value
        displayType = DisplayType.CustomParent;
        width = 100;
        break;
      case FieldType.TextField:
        propName = 'text';
        width = 100;
        break;
      case FieldType.CheckBox:
      case FieldType.SharedCheckBox:
        displayType = DisplayType.CustomChecked;
        propName = 'checked';
        width = 30;
        break;
      case FieldType.DateTime:
        propName = 'dateTimeValue';
        break;
      case FieldType.DropDownList:
      default:
        break;
    }

    return {
      fieldId: this.fieldId,
      displayTitle: this.displayTitle,
      databaseTitle: this.displayTitle,
      displayType: displayType,
      path: propName,
      width: width,
      rank: this.rank,
      type: this.type
    };
  }
}

export class SelectableCodingField extends CodingField {
  constructor(public selected: boolean, codingField: CodingField) {
    super(codingField);
  }
}
